import { useEffect, useState } from "react";
import api from "@/lib/api";
import { EmailStatusBadge } from "@/pages/CRM";

export default function CrmTab({ cid, companyNom }) {
  const [acts, setActs] = useState([]);
  const [form, setForm] = useState({ type: "appel", title: "", content: "" });

  const load = () => api.get("/activities", { params: { company_id: cid } }).then((r) => setActs(r.data));
  useEffect(() => { load(); }, [cid]);

  const add = async (e) => {
    e.preventDefault();
    if (!form.title.trim()) return;
    await api.post("/activities", { ...form, company_id: cid, company_nom: companyNom });
    setForm({ type: "appel", title: "", content: "" });
    load();
  };

  const icons = { appel: "📞", email: "✉️", reunion: "🤝", note: "📝", signature: "✍️", whatsapp: "💬", courrier: "📮" };
  return (
    <div className="grid lg:grid-cols-3 gap-6">
      <div className="bg-white border border-border p-5 h-fit">
        <div className="overline text-muted-foreground mb-3">Ajouter une interaction</div>
        <form onSubmit={add} className="space-y-3">
          <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} data-testid="crm-type"
            className="w-full px-3 py-2.5 text-sm border border-border bg-white outline-none focus:border-primary">
            <option value="appel">Appel</option><option value="email">Email</option>
            <option value="reunion">Réunion</option><option value="note">Note</option>
          </select>
          <input data-testid="crm-title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} placeholder="Objet"
            className="w-full px-3 py-2.5 text-sm border border-border outline-none focus:border-primary" />
          <textarea data-testid="crm-content" value={form.content} onChange={(e) => setForm({ ...form, content: e.target.value })} placeholder="Détails…" rows={3}
            className="w-full px-3 py-2.5 text-sm border border-border outline-none focus:border-primary" />
          <button data-testid="crm-add-btn" type="submit" className="w-full py-2.5 bg-primary text-white text-sm font-semibold hover:bg-blue-800">Enregistrer</button>
        </form>
      </div>
      <div className="lg:col-span-2">
        <div className="overline text-muted-foreground mb-3">Timeline</div>
        {acts.length === 0 && <div className="text-sm text-muted-foreground">Aucune interaction enregistrée.</div>}
        <div className="space-y-3">
          {acts.map((a) => (
            <div key={a.id} className="bg-white border border-border p-4 flex gap-3" data-testid="crm-activity">
              <div className="text-lg">{icons[a.type] || "📝"}</div>
              <div className="flex-1">
                <div className="flex items-center justify-between"><span className="font-semibold text-sm">{a.title}</span><span className="overline text-muted-foreground">{new Date(a.date).toLocaleDateString("fr-FR")}</span></div>
                {a.content && <p className="text-sm text-muted-foreground mt-1">{a.content}</p>}
                <div className="flex items-center gap-2 mt-1"><span className="overline text-muted-foreground">{a.type} · {a.author}</span>{a.type === "email" && <EmailStatusBadge status={a.email_status} />}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
